import { TRUST_URL } from "../lib/constants";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-inkdeep border-t border-white/8 py-16 sm:py-20" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-col md:flex-row justify-between gap-10">
        <div>
          <p className="font-display text-2xl tracking-[0.14em] text-cream">
            IRON GATE <span className="text-gold">CONSULTING</span>
          </p>
          <p className="text-[10px] tracking-[0.28em] text-cream/40 uppercase mt-2">Formerly Assets Secure USA</p>
        </div>
        <div className="flex flex-col gap-2.5 text-sm">
          <a href="mailto:support@igcfirm.com" data-testid="footer-email-link" className="text-cream/70 hover:text-gold transition-colors duration-300">
            support@igcfirm.com
          </a>
          <a href={TRUST_URL} data-testid="footer-portal-link" className="text-cream/70 hover:text-gold transition-colors duration-300">
            trust.igcfirm.com
          </a>
          <Link to="/privacy-policy" data-testid="footer-privacy-link" className="text-cream/70 hover:text-gold transition-colors duration-300">
            Privacy Policy
          </Link>
          <Link to="/terms-of-service" data-testid="footer-terms-link" className="text-cream/70 hover:text-gold transition-colors duration-300">
            Terms of Service
          </Link>
        </div>
      </div>
      <div className="h-px bg-white/8 my-10" />
      <p className="text-cream/45 text-sm">
        2026 Iron Gate Consulting. All rights reserved. Powered by Echo Holding Ventures Inc.
      </p>
      <p className="text-cream/35 text-xs leading-relaxed mt-4 max-w-3xl">
        Iron Gate Consulting is not a law firm. Legal review services are provided through veteran military
        benefits. Trust services are provided for estate planning purposes. Consult a licensed attorney for
        legal advice.
      </p>
    </div>
  </footer>
);
